import { render, staticRenderFns } from "./FabricSelectionPanel.vue?vue&type=template&id=73128d48&scoped=true"
import script from "./FabricSelectionPanel.vue?vue&type=script&lang=js"
export * from "./FabricSelectionPanel.vue?vue&type=script&lang=js"
import style0 from "./FabricSelectionPanel.vue?vue&type=style&index=0&id=73128d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73128d48",
  null
  
)

export default component.exports